export const ROUTES = {
  create: 'create',
  myOrders: 'my-orders',
  myOrdersDetail: (uuid = ':uuid') => `my-orders/${uuid}`
};

export const PUBLIC_LEGAL_LINKS = {
  privacyPolicy: 'https://storage.tech-drive.uz/public/docs/privacy-policy.pdf',
  userAgreement: 'https://storage.tech-drive.uz/public/docs/client-consent.pdf'
};

export enum Languages {
  uz = 'uz',
  ru = 'ru',
  en = 'en'
}
export const SUPPORTED_LANGUAGES = [Languages.uz, Languages.ru, Languages.en];

export const UZ_PHONE_MASK = '+998 (__) ___-__-__';

export const TOKEN_REFRESH_INTERVAL = 3 * 60 * 1000;

export const APPLICATION_STATUSES: Record<
  string,
  { id: string; color: string }
> = {
  add_queue: {
    id: 'add_queue',
    color: '#b85c15'
  },
  waiting_bank_response: {
    id: 'waiting_bank_response',
    color: '#f5a524'
  },
  approved: {
    id: 'approved',
    color: '#10b981'
  },
  financed: {
    id: 'financed',
    color: '#10b981'
  },
  rejected: {
    id: 'rejected',
    color: '#f10'
  },
  declined: {
    id: 'declined',
    color: '#f10'
  },
  cancelled: {
    id: 'cancelled',
    color: '#BFBFBF'
  },
  in_process: {
    id: 'in_process',
    color: '#0099FF'
  },
  waiting_of_financing: {
    id: 'waiting_of_financing',
    color: '#0099FF'
  },
  accepted_alternative: {
    id: 'accepted_alternative',
    color: '#10b981'
  },
  error: {
    id: 'error',
    color: '#f10'
  },
  draft: {
    id: 'draft',
    color: '#313A49'
  },
  created: {
    id: 'created',
    color: '#313A49'
  },
  completed: {
    id: 'completed',
    color: '#0CAF60'
  },
  in_work: {
    id: 'in_work',
    color: '#FFD023'
  },
  waiting_of_payment: {
    id: 'waiting_of_payment',
    color: '#1F9AFF'
  },
  waiting_for_upload_files: {
    id: 'waiting_for_upload_files',
    color: '#1f9aff'
  },
  on_rework: {
    id: 'on_rework',
    color: '#1F9AFF'
  },
  on_verification: {
    id: 'on_verification',
    color: '#FFD023'
  },
  financed_pledge_missing: {
    id: 'financed_pledge_missing',
    color: '#1F9AFF'
  },
  sms_verificating: {
    id: 'sms_verificating',
    color: '#023D3D'
  },
  pre_approved: {
    id: 'pre_approved',
    color: '#0CAF60'
  },
  mobile_client: {
    id: 'mobile_client',
    color: '#1F9AFF'
  },
  financed_waiting_for_modification_before_pledge: {
    id: 'financed_waiting_for_modification_before_pledge',
    color: '#1F9AFF'
  },
  refunded: {
    id: 'refunded',
    color: '#a8a8a8'
  }
};
